import { getInvoiceById } from "@/services/invoices.service";
import { useQuery } from "@tanstack/react-query";

export const useInvoice = (id, options = {}) => {
  return useQuery({
    queryKey: ["invoice", id],
    queryFn: () => getInvoiceById(id),
    enabled: Boolean(id),
    select: (res) => res?.data,
    ...options,
  });
};
